import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { raporKategorileri } from '../utils/raporListesi';

// v1.29.0 — Raporlar: kullanıcının yetkili olduğu raporlar kategorilere ayrılmış olarak listelenir
const RaporMerkezi: React.FC = () => {
  const { t } = useTranslation();
  const { hasPermission } = useAuth();
  const kategoriler = raporKategorileri(hasPermission);

  return (
    <div className="rm-sayfa">
      <style>{`
        .rm-sayfa { padding: 24px; font-family: 'Inter','Segoe UI',sans-serif; color: #1f2937; }
        .rm-baslik { font-size: 22px; font-weight: 700; color: #111827; margin: 0 0 4px; letter-spacing: -0.025em; }
        .rm-alt { font-size: 13.5px; color: #6b7280; margin: 0 0 24px; }
        .rm-kategori { margin-bottom: 26px; }
        .rm-kategori-baslik { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 700; color: #374151; margin: 0 0 10px; }
        .rm-kategori-sayi { background: #f1f5f9; color: #64748b; font-size: 11px; font-weight: 700; border-radius: 9999px; padding: 1px 8px; }
        .rm-izgara { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 12px; }
        .rm-kart { display: flex; align-items: center; gap: 14px; background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 14px 16px; text-decoration: none; color: inherit; transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s; }
        .rm-kart:hover { border-color: #cd6906; box-shadow: 0 4px 14px rgba(15,23,42,0.07); transform: translateY(-1px); color: inherit; }
        .rm-ikon { width: 40px; height: 40px; flex-shrink: 0; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 16px; }
        .rm-metin { flex: 1; min-width: 0; }
        .rm-ad { font-size: 13.5px; font-weight: 600; color: #111827; }
        .rm-aciklama { font-size: 12px; color: #6b7280; margin-top: 2px; line-height: 1.4; }
        .rm-ok { color: #cbd5e1; font-size: 11px; }
        .rm-kart:hover .rm-ok { color: #cd6906; }
        .rm-bos { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 48px 24px; text-align: center; color: #94a3b8; font-size: 13.5px; }
        @media (max-width: 768px) { .rm-sayfa { padding: 16px 12px; } }
      `}</style>

      <h1 className="rm-baslik">{t('menu.raporlar', 'Raporlar')}</h1>
      <p className="rm-alt">{t('raporMerkezi.aciklama', 'Yetkiniz olan raporlara buradan ulaşabilirsiniz.')}</p>

      {kategoriler.length === 0 ? (
        <div className="rm-bos">{t('raporMerkezi.yok', 'Erişebileceğiniz rapor bulunmuyor.')}</div>
      ) : kategoriler.map(k => (
        <section key={k.id} className="rm-kategori">
          <h2 className="rm-kategori-baslik">
            <i className={k.ikon} style={{ color: k.renk }}></i>
            {t(`raporMerkezi.kategori.${k.id}`, k.baslik)}
            <span className="rm-kategori-sayi">{k.raporlar.length}</span>
          </h2>
          <div className="rm-izgara">
            {k.raporlar.map(r => (
              <Link key={r.id} to={r.yol} className="rm-kart">
                <span className="rm-ikon" style={{ background: `${k.renk}14`, color: k.renk }}><i className={r.ikon}></i></span>
                <span className="rm-metin">
                  <div className="rm-ad">{t(`raporMerkezi.${r.id}.baslik`, r.baslik)}</div>
                  <div className="rm-aciklama">{t(`raporMerkezi.${r.id}.aciklama`, r.aciklama)}</div>
                </span>
                <i className="fas fa-chevron-right rm-ok"></i>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default RaporMerkezi;
